import './RangeSlider.pcss';
import InitializationError from '@naturehouse/nh-essentials/lib/exceptions/InitializationError';

export type RangeSliderProps = {
    name: string;
    max: number;
    min?: number;
    step?: number;
    value?: number;
    unit?: string;
};

export default class RangeSlider extends HTMLElement {
    readonly #input = this.querySelector('input.nh-range-slider__input') as HTMLInputElement;

    readonly #labelValue = this.querySelector('[data-role="label-value"]') as HTMLDataElement;

    get value(): number {
        return Number(this.#input.value);
    }

    set value(value: number) {
        this.#input.value = value.toString();
        this.#handleValueChange();
    }

    public connectedCallback(): void {
        if (this.#input === null || this.#labelValue === null) {
            throw new InitializationError();
        }

        this.#handleValueChange();
        this.#input.addEventListener('input', this.#handleValueChange);
    }

    public disconnectedCallback(): void {
        this.#input?.removeEventListener('input', this.#handleValueChange);
    }

    #setValue(): void {
        this.#labelValue.innerText = this.#input.value;
        this.#labelValue.value = this.#input.value;
    }

    #setProgress = (): void => {
        this.style.setProperty('--min', `${this.#input.min}`);
        this.style.setProperty('--max', `${this.#input.max}`);
        this.style.setProperty('--value', `${this.#input.value}`);
        this.style.setProperty('--step', `${this.#input.step}`);
    };

    #handleValueChange = (): void => {
        this.#setValue();
        this.#setProgress();
    };
}

if (!customElements.get('nh-range-slider')) {
    customElements.define('nh-range-slider', RangeSlider);
}
